export const ultimasNoticias = [
    
   //   {
   //      "imagen" : "assets/imgs/comisionpermanente.jpeg",

   //      "url" : "https://www.facebook.com/photo.php?fbid=1141667654661088&set=pb.100064535929070.-2207520000&type=3&locale=es_LA",
   //      "titulo" : "Contralores México",
       
   //     "fecha" : "Contralores México",
   //   }, 
   //   {
   //      "imagen" : "assets/imgs/CONTRALORIASOCIAL12.jpg",

   //      "url" : "https://www.facebook.com/share/p/1F7xuoj15B/",
   //      "titulo" : "Premio Nacional de Contralores ",
       
   //     "fecha" : "Contraloría Social",
   //   }, 


   //   {
   //      "imagen" : "assets/imgs/convocsatorias (2).jpg",
   //      "url" : "https://s-contraloria.hidalgo.gob.mx/interes/Convocatoria-Transparencia-en-Corto-2025.pdf",

   //      "titulo" : "Premio Nacional de Contralores ",
   //       "fecha" : "Contraloría Social",
   //  }, 

 
    {
        "imagen" : "assets/imgs/rutastrasformacion.jpg",
        "url" : "https://www.facebook.com/share/p/19PZhzmbKp",
        "titulo" : "Secretaría de Contraloría Hidalgo",
        "fecha" : "Cuarta Sesión Ordinaria de la Comisión Permanente de Contralores Estado-Municipio de la Región VI.",
    },

    
     {
        "imagen" : "assets/imgs/rutastransformacion.jpg",
        "url" : "https://www.facebook.com/share/p/1EdHpYWJzJ/",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "Rutas de la Transformación.",    
       
    }, 
    
    {
        "imagen" : "assets/imgs/gabinete.jpg",
        "url" : "https://www.facebook.com/share/p/18u7G5c72s/",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "Reunión mensual de gabinete.",
    },     
  
    {
        "imagen" : "assets/imgs/superagentes.jpg",
         "url" : "https://www.facebook.com/share/p/19Ppnxoj8R/",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "Los Súper Agentes de la Contraloría .",
    },
   

     {
        "imagen" : "assets/imgs/requisitos.jpg",
        "url" : "https://www.facebook.com/share/p/1CwVfwVvpE/",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "Si tienes entre 15 y 25 años, participa en el Concurso Nacional Transparencia en Corto 2026.",
    },
    {
        "imagen" : "assets/imgs/lunescivico.jpg",
         "url" : "https://www.facebook.com/share/v/1Ekror4DQn",
        "titulo" : "Secretaría de Contraloría Hidalgo",
       "fecha" : "El lunes cívico reafirma el compromiso con los valores cívicos.",
    },

 
 
 
    // {
    //     "imagen" : "noticias/comision.gif",
    //      "url" : "https://comisioncontralores.gob.mx/2023/",
    //     "titulo" : "Comisión Permanente de Contralores ",
    //    "fecha" : "Estados-Federación",
    // },     

    // {
    //     "imagen" : "noticias/9_jornada.jpg",
    //      "url" : "https://www.facebook.com/SecretariaContraloriaHgo/videos/1141123597339219/?mibextid=rS40aB7S9Ucbxw6v",
    //     "titulo" : "9 JORNADA DE CAPACITACIÓN ",
    //    "fecha" : "PARA LA TRANSFORMACIÓN DE HIDALGO",
    // },
    // {
    //     "imagen" : "noticias/convenio.jpg",
    //     "url" : "https://www.facebook.com/SecretariaContraloriaHgo/videos/1156571106119065",
    //     "titulo" : "Firma de Convenio de Donación de Sistemas por la Secretaría de la Honestidad ",
    //     "fecha" : "y la Secretaría de Contraloría de Hidalgo."
    // },
   


    // {
    //     "imagen" : "noticias/2da sesion.png",
    //     "url" : "https://www.facebook.com/share/p/14qTV3iovd/?mibextid=WC7FNe",
    //     "titulo" : " Segunda Asamblea Plenaria de la Comisión Permanente de Contralores Estado-Municipios",
    //     "fecha" : "28 de noviembre del 2024"
    // },



]